<template>
  <empresa-container>
    <loading :active="isLoading" :can-cancel="false" :is-full-page="fullPage" :opacity="1"></loading>
    <div class="vld-parent">
      <cook-logo v-if="!this.$store.state.empresaVerificada"></cook-logo>
      <div class="navbar-lower">
        <nav-bar :grupos="this.$store.state.grupos" style="z-index: 1002;">
          <!-- <div class="nav-content nav-content-s" @click="Pesquisar()">
            <div class="nav-wrapper">
              <nav>
                <div class="nav-wrapper">
                  <form>
                    <div class="input-field"
                         :style="'background-color:white;border-style: solid;border-width: 1px;border-color: '+ this.$store.state.empresa.cor_primaria+';color:'+ this.$store.state.empresa.cor_primaria ">
                      <input id="search" type="search" required placeholder="O que você procura?">
                      <label class="label-icon" for="search" :style="'color:'+ this.$store.state.empresa.cor_primaria "><i
                        class="material-icons"
                        :style="'color:'+ this.$store.state.empresa.cor_primaria ">search</i></label>
                      <i class="material-icons">close</i>
                    </div>
                  </form>
                </div>
              </nav>
            </div>
          </div> -->
        </nav-bar>
      </div>
      <div v-if="this.$store.state.empresaVerificada">
        <div :style="'background-color:' + this.$store.state.empresa.cor_cardapio_fundo">
          <logo-empresa></logo-empresa>
          <informacoes-empresa></informacoes-empresa>
          <div class="container">
            <div class="nav-content nav-content-s" @click="Pesquisar()">
              <div class="nav-wrapper">
                <nav>
                  <div class="nav-wrapper">
                    <form>
                      <div class="input-field"
                           :style="'background-color:white;border-style: solid;border-width: 1px;border-color: '+ this.$store.state.empresa.cor_primaria+';color:'+ this.$store.state.empresa.cor_primaria ">
                        <input id="search" type="search" required placeholder="O que você procura?">
                        <label class="label-icon" for="search" :style="'color:'+ this.$store.state.empresa.cor_primaria "><i
                          class="material-icons"
                          :style="'color:'+ this.$store.state.empresa.cor_primaria ">search</i></label>
                        <i class="material-icons">close</i>
                      </div>
                    </form>
                  </div>
                </nav>
              </div>
            </div>
          </div>
          <br>
          <div class="container">
            <div class="page-section" v-if="$store.state.produtosPromocaoBool">
              <titulo-destacado fundo="#e51c23" :titulo="this.$store.state.grupoPromocional.nome"
                                style="color: white"></titulo-destacado>
              <br>
              <div class="row">
                <card v-for="produto in this.$store.state.produtosPromocao" :produto="produto" :em-promocao="true"
                      :key="'itempromocao-'+produto.id"></card>
              </div>
            </div>
            <div class="page-section">
              <titulo-destacado :fundo="'white'" titulo="TODOS OS DEPARTAMENTOS"
                                :style="'border-style: solid;border-width: 1px;border-color: '+ this.$store.state.empresa.cor_primaria+';color:'+ this.$store.state.empresa.cor_primaria "></titulo-destacado>

              <div class="row">
                <br>
                <destaques v-for="grupo in this.$store.state.grupos" :grupo="grupo"
                           :key="'grupo-'+grupo.grupo.id"></destaques>
              </div>
            </div>
          </div>
          <meu-pedido-bloco-flutuante-component></meu-pedido-bloco-flutuante-component>
        </div>
      </div>
    </div>

  </empresa-container>
</template>

<script>
import MeuPedidoBlocoFlutuanteComponent from "../Widgets/MeuPedidoBlocoFlutuanteComponent";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import CookLogo from "../Widgets/CookLogo";
import TituloDestacado from "../Widgets/TituloDestacado";
import NavBar from "../Widgets/NavBar";
import Item from "../Widgets/Item";
import LogoEmpresa from "../Widgets/LogoEmpresa";
import InformacoesEmpresa from "../Widgets/InformacoesEmpresa";
import MenuHorizontal from "../Widgets/MenuHorizontal";
import Card from "../Widgets/Produto/Card";
import Destaques from "../Widgets/Grupos/Destaques";
import EmpresaContainer from "../Widgets/EmpresaContainer";
import CaixaPesquisa from "../Widgets/Pesquisa/CaixaPesquisa";

export default {
  name: "Cardapio",
  data() {
    return {
      empresaExiste: false,
      isLoading: false,
      fullPage: true,
      opacity: 1,
      dias: []
    }
  },
  updated() {
    document.getElementById("bodyMain").style =
      "background-color: " + this.$store.state.empresa.cor_cardapio_fundo;


    try {
        setTimeout(()=>{
          if (this.$route.query.produto) {
            this.$router.push('/' + this.$store.state.empresa_url + '/menu/pesquisar?produto=' + this.$route.query.produto);
          }
        },3000);
    } catch (exception) {
    }

  },
  mounted() {

    if (this.$route.query.produto) {
      this.isLoading = true;
    }

    let grupoLink = '';
    try {
      if (this.$route.query.grupo) {
        grupoLink = this.$route.query.grupo;
        setTimeout(() => {
          this.$router.replace({'query': null});
        }, 500);
        let countstateCheck = 0;
        let stateCheck = setInterval(() => {
          if (document.getElementById("gid" + grupoLink)) {
            clearInterval(stateCheck);
            if (document.getElementById("gid" + grupoLink)) {
              document.getElementById("gid" + grupoLink).click();
            } else {
              countstateCheck = countstateCheck + 1;
              if (countstateCheck > 60) {
                clearInterval(stateCheck);
              }
            }
          }
        }, 1000);
      }
    } catch (exception) {
    }

    $(document).ready(function () {
      $('.materialboxed').materialbox();
      $('.collapsible').collapsible();
      $('.scrollspy').scrollSpy();
      $('.tabs').tabs();
      $('ul.tabs').tabs();
      $('.modal').modal();
      $('.sidenav').sidenav();
      $('.dropdown-trigger').dropdown();
      // $(".nav-content-s").hide();

    });



  },
  components: {
    CaixaPesquisa,
    EmpresaContainer,
    Destaques,
    Card,
    MenuHorizontal,
    InformacoesEmpresa,
    LogoEmpresa, Item, NavBar, TituloDestacado, CookLogo, MeuPedidoBlocoFlutuanteComponent, Loading
  },
  methods: {
    Pesquisar() {
      this.$router.push('/' + this.$store.state.empresa_url + '/menu/pesquisar')
    }
  }
}


$(window).scroll(function () {
  // var scroll = $(window).scrollTop();
  // if (scroll >= 100) {
  //   $(".nav-content-s").show();
  // } else {
  //   $(".nav-content-s").hide();
  // }
});


</script>

<style scoped>
div.scrollmenu {
  /*background-color: #333;*/
  overflow: auto;
  white-space: nowrap;
}

div.scrollmenu a {
  display: inline-block;
  /*color: white;*/
  text-align: center;
  padding: 14px;
  text-decoration: none;
}

div.scrollmenu a:hover {
  background-color: #777;
}

@media only screen and (min-width: 601px) {
  nav, nav .nav-wrapper i, nav a.sidenav-trigger, nav a.sidenav-trigger i {
    height: 40px;
    line-height: 40px;
  }
}

@media only screen and (max-device-width: 768px) {
  /* Styles */
  .container {
    margin: 0 auto;
    max-width: 1280px;
    width: 97%;
  }
}

.fixed-action-btn {
  position: fixed;
  right: 23px;
  bottom: 60px;
  padding-top: 15px;
  margin-bottom: 0;
  z-index: 997;
}
</style>



// WEBPACK FOOTER //
// src/components/Paginas/Cardapio.vue